import React from 'react'

class Lazy extends React.Component {
  state = {
    component: null,
  }

  componentDidMount = () => {
    const { fun } = this.props
    fun().then(mod => {
      this.setState({ component: mod.default })
    })
  }

  render() {
    const { props } = this.props
    const { component: Component } = this.state
    if (Component) {
      return <Component {...props} />
    }
    return <div>loading...</div>
  }
}

export default fun => props => <Lazy fun={fun} props={props} />